import dayjs from "dayjs";

export default class AppUtil {

  getBaseUrl() {
    if (process.env.NODE_ENV === "development") {
      return "http://localhost:3000";
    }

    if (location.hostname === "admin-test.streetmetrics.io") {
      return "https://helios-dev.streetmetrics.io";
    }
    
    return "https://dashboard.streetmetrics.io";
  }

  getPipelineUrl() {
    if (process.env.NODE_ENV === "development") {
      return "http://localhost:8080";
    }

    return "https://process.streetmetrics.io";
  }

  getBackfillUrl() {
    if (process.env.NODE_ENV === "development") {
      return "http://localhost:8080";
    }

    return "https://backfill.streetmetrics.io";
  }

  formatStartAndEndDates(startDate, endDate) {
    const dateFormatOptions = {year: "numeric", month: "2-digit", day: "2-digit"}
    let startFilter = startDate.toLocaleDateString('en-CA', dateFormatOptions).replaceAll('/', '-')
    let endFilter = endDate.toLocaleDateString('en-CA', dateFormatOptions).replaceAll('/', '-')
    return {start: startFilter, end: endFilter};
  }

  getDayLabel(dayOfWeek) {
    if (dayOfWeek === 0) {
      return 'Sunday'
    } else if (dayOfWeek === 1) {
      return 'Monday'
    } else if (dayOfWeek === 2) {
      return 'Tuesday'
    } else if (dayOfWeek === 3) {
      return 'Wednesday'
    } else if (dayOfWeek === 4) {
      return 'Thursday'
    } else if (dayOfWeek === 5) {
      return 'Friday'
    } else if (dayOfWeek === 6) {
      return 'Saturday'
    }
  }

  getDateStrings(startDateString, endDateString) {
    const dateStrings = []
    const startDate = dayjs(startDateString)
    const endDate = dayjs(endDateString)

    let currentDate = startDate

    while (!currentDate.isAfter(endDate)) {
      dateStrings.push(currentDate.format('YYYY-MM-DD'));
      currentDate = currentDate.add(1, 'day');
    }

    return dateStrings
  }

  getFilterDates(filterType) {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    const end = new Date();
    end.setHours(23, 59, 59, 999);

    if (filterType === 'lastWeek') {
      // Last week (Monday to Sunday)
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday, etc.
      const mondayOffset = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Convert Sunday to 6, others to day - 1
      
      start.setDate(today.getDate() - mondayOffset - 7); // Go back to last Monday
      end.setDate(start.getDate() + 6); // Sunday of last week
      end.setHours(23, 59, 59, 999);
    } else if (filterType === 'currentWeek') {
      // Current week (Monday to today or Sunday if week is complete)
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday, etc.
      const mondayOffset = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Convert Sunday to 6, others to day - 1
      
      start.setDate(today.getDate() - mondayOffset); // This Monday
      end.setTime(today.getTime()); // Today
      end.setHours(23, 59, 59, 999);
    } else if (filterType === 'lastMonth') {
      // Last month (1st to last day of previous month)
      const today = new Date();
      start.setMonth(today.getMonth() - 1, 1); // 1st of last month
      end.setMonth(today.getMonth(), 0); // Last day of last month
      end.setHours(23, 59, 59, 999);
    } else if (filterType === 'currentMonth') {
      // Current month (1st to today)
      const today = new Date();
      start.setDate(1); // 1st of current month
      end.setTime(today.getTime()); // Today
      end.setHours(23, 59, 59, 999);
    } else if (filterType === 'yesterday') {
      // Legacy support
      start.setDate(start.getDate() - 1);
      end.setDate(end.getDate() - 1);
    } else if (filterType === 'last7') {
      // Legacy support
      start.setDate(start.getDate() - 7);
      end.setDate(end.getDate() - 1);
    } else if (filterType === 'last30') {
      // Legacy support
      start.setDate(start.getDate() - 30);
      end.setDate(end.getDate() - 1);
    } else if (filterType === 'last3') {
      // Legacy support
      start.setDate(start.getDate() - 3);
      end.setDate(end.getDate() - 1);
    }

    return {start: start, end: end};
  }

  getImportantMarkets() {
    let importantMarkets = ['Boston', 'Detroit', 'Flint-Saginaw-Bay City', 'Lansing', 'Las Vegas', 'Miami-Ft. Lauderdale',
      'Phoenix', 'SAN FRANCISCO-OAK-SAN JOSE', 'Washington, DC', 'Atlanta', 'Chicago', 'Los Angeles', 'MINNEAPOLIS-ST. PAUL',
      'New York', 'PHILADELPHIA', 'Portland, OR', 'SEATTLE-TACOMA']

    let matches = []

    for( let i = 0; i < streetmetrics.model.markets.length; i++ ) {
      for( let j = 0; j < importantMarkets.length; j++ ) {

        if(streetmetrics.model.markets[i].marketName === importantMarkets[j].toUpperCase()) {
          matches.push(streetmetrics.model.markets[i])
          continue
        }
      }
    }

    return matches
  }

  downloadCSV(data, filename, headers = '') {
    const csvContent = headers + data
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
